import React, { Component, ReactNode, ErrorInfo } from "react";
import ErrorComponent from "./ErrorComponent";

interface ErrorBoundaryProps {
    children: ReactNode;

    onCriticalError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

/*This doesn't catch errors from: event handlers, async code, server-side rendering*/
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        // Update state to indicate an error occurred
        return {
            hasError: true
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // Log error to the console
        console.error("Unhandled error caught in ErrorBoundary: ", error, errorInfo);

        // Call the critical error handler if provided
        if (this.props.onCriticalError) {
            this.props.onCriticalError(error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorComponent />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;